<template>
    <div class="contact-us full-screen">
        <div class="wrapper wrapper-full-page section content bg-image-self">
            <!-- <div v-if="this.$store.state.permit.RulesUser.roles.includes('staff')"></div> -->
            <div class="container">
                <Keypress :multiple-keys="multiple" key-event="keyup"  @success="checkselfScan" @wrong="otherMethod" />
                <!-- <b-input hidden v-model="valKey"></b-input> -->
                <!-- <p class="mt-2 mb-2">TokenID : {{ valKey }}</p> -->
            </div>
            <div class="container-fulid" style="width: 99%;">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <h3 style="font-weight:100" class="mt-5 font-en mb-1">
                            <strong class="font-en font-weight-bold">Covid 19</strong>
                        </h3>
                        <h5 style="font-weight:100" class="mt-1 font-en mb-1">
                            <strong class="font-en font-weight-bold">Nakhon Pathom's Self-Screening</strong>
                        </h5>
                        <p class="mt-1 mb-5 font-en text-danger">*** Support student only ***</p>
                        <b-media>
                            <template #aside>
                                <img class="thumbnail" src="@/assets/img/avatar.png" style="width:250px;height:300px;" alt="icon_std">
                            </template>
                            <h5 class="mt-3 mb-4 font-weight-bold"><i class="fa fa-address-card-o fa-2x" aria-hidden="true" /></h5>
                            <b-input-group size="lg">
                                <template #prepend>
                                    <b-input-group-text class="font-en">STUDENT : ID / CARD ID</b-input-group-text>
                                </template>
                                <b-form-input v-model="valKeyInput" type="number"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="valKeyInput === ''" @click="checkselfBtn" size="lg" class="font-en" variant="success">Add</b-button>
                                    <b-button @click="reloadpage" size="lg" class="font-en" variant="danger">clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <!-- error msg -->
                            <b-alert v-if="msgerror" class="mt-4 mb-3" show variant="dangercus" dismissible>
                                <h5 class="font-en mt-2 mb-2">Please try to scan your card again.</h5>
                                <p class="font-thai mt-1 mb-2">โปรดลองสแกนบัตรของท่านอีกครั้ง</p>
                            </b-alert>
                            <b-alert class="mt-2" show variant="infoP">
                                <p class="mt-2 font-en-chk">Detail:</p>
                                <hr>
                                <p v-if="objSelfCheck.id !== '0000'" class="font-en mt-1 mb-2 ml-3">ID : {{ objSelfCheck.id }}</p>
                                <p 
                                    :class="{ 
                                        'h3 text-success':objSelfCheck.status === 'pass' , 
                                        'h4 text-warning':objSelfCheck.status === 'DUPP' , 
                                        'h4 text-danger':objSelfCheck.status === 'reject'
                                    }" 
                                    class="font-en mt-1 mb-2 ml-3"
                                >
                                    <span class="text-muted" v-if="objSelfCheck.status  === ''">SCAN CARD ID</span>
                                    <span v-if="objSelfCheck.status  === 'pass'">Status : Pass</span>
                                    <span class="font-thai" v-if="objSelfCheck.status  === 'DUPP'">Status : ท่านได้ส่ง Nakhon Pathom's Self-Screening Form เรียบร้อยเเล้ว</span>
                                    <span v-if="objSelfCheck.status  === 'reject'">Status : Not Pass</span>
                                </p>
                            </b-alert>
                        </b-media>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal DUPPLICATION -->
        <b-modal ref="modal-dupplication" header-bg-variant="info" header-text-variant="light" hide-footer>
            <template v-slot:modal-title>
                <h4 class="font-thai mt-1 mb-2">
                    <i class="fa fa-info fa-lg" aria-hidden="true" />
                </h4>
            </template>
            <b-card-text class="text-center mb-3">
                <h4 class="font-thai mt-2 mb-1">
                    <i class="fa fa-check mr-2 text-success" aria-hidden="true" />ท่านได้ส่ง
                </h4>
                <h5 class="font-en mt-2 mb-1"><strong>Nakhon Pathom's Self-Screening Form</strong></h5>
            </b-card-text>
        </b-modal>
        <!-- Modal No Content -->
        <b-modal ref="modal-nocontent" header-bg-variant="danger" header-text-variant="light" hide-footer>
            <template v-slot:modal-title>
                <h4 class="font-thai mt-1 mb-2">ไม่พบข้อมูลบัตร</h4>
            </template>
            <b-card-text class="mb-3">
                <p class="font-thai mt-2 mb-1">เพิ่มข้อมูลโดยวิธี</p>
                <p class="font-thai mt-2 mb-1">
                    คลิกที่<a rel="noopener noreferrer" class="ml-2 font-thai" target="_blank" href="https://my.muic.io/#/addcard"><b-button size="sm" variant="info">Add Card</b-button></a>
                </p>
            </b-card-text>
        </b-modal>
        <!-- Modal new -->
        <b-modal ref="modal-new" hide-footer>
            <template v-slot:modal-title>
                <h5 class="mt-1 mb-1">
                    <strong class="font-thai"><i class="fa fa-user mr-1" aria-hidden="true"/>นักศึกษาใหม่</strong>
                </h5>
            </template>
            <b-card-text class="mb-3">
                <h5 class="font-thai mt-1 mb-2">ระบุ รหัสนักศึกษา</h5>
                <b-form-input size="lg" v-model="addNewID" type="number"></b-form-input>
                <div class="mt-3" v-if="loadADD">
                    <b-spinner small type="grow"></b-spinner><span class="ml-1 font-thai font-s-1">กำลังดำเนินการเพิ่มข้อมูล</span>
                </div>
                <div v-else>
                    <div class="mt-3 text-right">
                        <b-button :disabled="addNewID === ''" class="mr-3 font-thai font-s-1 mt-0 text-dark" variant="warning">
                            <i class="fa fa-plus mr-1" aria-hidden="true"/>เพิ่มข้อมูล
                        </b-button>
                        <b-button class="font-thai font-s-1 mt-0" @click="closeModalNewStd" variant="danger">
                            ปิด
                        </b-button>
                    </div>
                </div>
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
    export default {
        components: {
            Keypress: () => import('vue-keypress'),
        },
        computed: {},
        data(){
            return{
                msgerror:false,
                loadADD:false,
                valKey: '',
                valKeyInput:'',
                valTemp: 'Key name',
                multiple: [
                    {
                        keyCode: 13, // Enter
                        modifiers: [],
                        preventDefault: true,
                    },
                ],
                addNewID: '',
                objSelfCheck:{
                    id:'',
                    status: '',
                },
            }
        },
        methods:{
            reloadpage(){
                location.reload()
            },
            modalNewStd(){
                this.addNewID = ''
                this.$refs['modal-new'].show() 
            },
            closeModalNewStd(){
                this.addNewID = ''
                this.$refs['modal-new'].hide()
            },
            clearDataObj(){
                this.valKey = ''
                this.valKeyInput = ''
                this.objSelfCheck.id = ''
                this.objSelfCheck.status = ''
                this.$refs['modal-nocontent'].hide()
                // this.$refs['modal-dupplication'].hide()
            },
            async checkselfBtn(){
                this.valKey = this.valKeyInput
                this.checkselfScan()
            },
            async checkselfScan(response) {
                this.objSelfCheck.id = ''
                this.objSelfCheck.status = ''
                try {
                    this.valKeyInput = this.valKey
                    const resSCAN = await this.$http.get(`/checkcovid19/survey/add_data/?staff_id=${this.valKey}`)
                    this.valKey = ''
                    this.valKeyInput = ''
                    if(resSCAN.status === 200){
                        if(resSCAN.data.code_id[0] === 'check survey covid with this code id already exists.'){
                            this.objSelfCheck.id = '0000'
                            this.objSelfCheck.status = 'DUPP'
                            // this.$refs['modal-dupplication'].show() 
                        }else{
                            this.objSelfCheck.id = resSCAN.data.code_id
                            this.objSelfCheck.status = resSCAN.data.status
                        }
                    }else if(resSCAN.status === 204){
                        this.$refs['modal-nocontent'].show()
                    }
                } catch (error) {
                    this.msgerror = true   
                }
                // clear
                setTimeout( ()=> 
                    this.clearDataObj()
                , 1500);
            },
            otherMethod(response){
                // console.log(response.event.keyCode)
                if(response.event.keyCode >= 48 && response.event.keyCode <= 57){
                    var temp = response.event.keyCode-48
                    this.valKey += `${temp}`
                }else if(response.event.keyCode >= 96 && response.event.keyCode <= 105){
                    var temp = response.event.keyCode-96
                    this.valKey += `${temp}`
                }else if(response.event.keyCode === 8 || response.event.keyCode === 46){
                    this.valKey = this.valKey.substring(0, this.valKey.length - 1);
                }else if(response.event.keyCode == 188){
                    this.valKey = this.valKey+','
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@500&family=Sarabun:wght@500&display=swap');
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-s-1{ font-size: 1.25rem; }
    .font-en{ font-family: 'Rubik', sans-serif; font-weight: 300; }
    .alert-infoP {
        background-color: #433e6d;
        color: #ffffff;
    }
    .alert-dangercus {
        background-color: #ffcaca;
        color: #000000;
        border-radius: 10px;
    }
    .bg-image-self {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg-selfscreen.png");
    }
</style>

